import MadeInUsaIcon from "./images/categories/made-in-usa.svg";
import Ecofriendly from "./images/categories/ecofriendly.svg";
import Handmade from "./images/categories/handmade.svg";
import SocialGood from "./images/categories/social-good.svg";

export const US_ISO = 'USA';
export const CANADA_ISO = 'CAN';

export const STATE_PROVINCE_SHORTHAND_TO_NAME = {
  'AL': 'Alabama',
  'AK': 'Alaska',
  'AZ': 'Arizona',
  'AR': 'Arkansas',
  'CA': 'California',
  'CO': 'Colorado',
  'CT': 'Connecticut',
  'DE': 'Delaware',
  'DC': 'District of Columbia',
  'FL': 'Florida',
  'GA': 'Georgia',
  'HI': 'Hawaii',
  'ID': 'Idaho',
  'IL': 'Illinois',
  'IN': 'Indiana',
  'IA': 'Iowa',
  'KS': 'Kansas',
  'KY': 'Kentucky',
  'LA': 'Louisiana',
  'ME': 'Maine',
  'MD': 'Maryland',
  'MA': 'Massachusetts',
  'MI': 'Michigan',
  'MN': 'Minnesota',
  'MS': 'Mississippi',
  'MO': 'Missouri',
  'MT': 'Montana',
  'NE': 'Nebraska',
  'NV': 'Nevada',
  'NH': 'New Hampshire',
  'NJ': 'New Jersey',
  'NM': 'New Mexico',
  'NY': 'New York',
  'NC': 'North Carolina',
  'ND': 'North Dakota',
  'OH': 'Ohio',
  'OK': 'Oklahoma',
  'OR': 'Oregon',
  'PA': 'Pennsylvania',
  'PR': 'Puerto Rico',
  'RI': 'Rhode Island',
  'SC': 'South Carolina',
  'SD': 'South Dakota',
  'TN': 'Tennessee',
  'TX': 'Texas',
  'UT': 'Utah',
  'VT': 'Vermont',
  'VA': 'Virginia',
  'WA': 'Washington',
  'WV': 'West Virginia',
  'WI': 'Wisconsin',
  'WY': 'Wyoming',
  'AB': 'Alberta',
  'BC': 'British Columbia',
  'MB': 'Manitoba',
  'NB': 'New Brunswick',
  'NL': 'Newfoundland',
  'NS': 'Nova Scotia',
  'NT': 'Northwest Territories',
  'NU': 'Nunavut',
  'ON': 'Ontario',
  'PE': 'Prince Edward Island',
  'QC': 'Quebec',
  'SK': 'Saskatchewan',
  'YT': 'Yukon'
};

export const USA_STATES = [
  {value: 'AL', label: 'Alabama'},
  {value: 'AK', label: 'Alaska'},
  {value: 'AZ', label: 'Arizona'},
  {value: 'AR', label: 'Arkansas'},
  {value: 'CA', label: 'California'},
  {value: 'CO', label: 'Colorado'},
  {value: 'CT', label: 'Connecticut'},
  {value: 'DE', label: 'Delaware'},
  {value: 'DC', label: 'District of Columbia'},
  {value: 'FL', label: 'Florida'},
  {value: 'GA', label: 'Georgia'},
  {value: 'HI', label: 'Hawaii'},
  {value: 'ID', label: 'Idaho'},
  {value: 'IL', label: 'Illinois'},
  {value: 'IN', label: 'Indiana'},
  {value: 'IA', label: 'Iowa'},
  {value: 'KS', label: 'Kansas'},
  {value: 'KY', label: 'Kentucky'},
  {value: 'LA', label: 'Louisiana'},
  {value: 'ME', label: 'Maine'},
  {value: 'MD', label: 'Maryland'},
  {value: 'MA', label: 'Massachusetts'},
  {value: 'MI', label: 'Michigan'},
  {value: 'MN', label: 'Minnesota'},
  {value: 'MS', label: 'Mississippi'},
  {value: 'MO', label: 'Missouri'},
  {value: 'MT', label: 'Montana'},
  {value: 'NE', label: 'Nebraska'},
  {value: 'NV', label: 'Nevada'},
  {value: 'NH', label: 'New Hampshire'},
  {value: 'NJ', label: 'New Jersey'},
  {value: 'NM', label: 'New Mexico'},
  {value: 'NY', label: 'New York'},
  {value: 'NC', label: 'North Carolina'},
  {value: 'ND', label: 'North Dakota'},
  {value: 'OH', label: 'Ohio'},
  {value: 'OK', label: 'Oklahoma'},
  {value: 'OR', label: 'Oregon'},
  {value: 'PA', label: 'Pennsylvania'},
  {value: 'PR', label: 'Puerto Rico'},
  {value: 'RI', label: 'Rhode Island'},
  {value: 'SC', label: 'South Carolina'},
  {value: 'SD', label: 'South Dakota'},
  {value: 'TN', label: 'Tennessee'},
  {value: 'TX', label: 'Texas'},
  {value: 'UT', label: 'Utah'},
  {value: 'VT', label: 'Vermont'},
  {value: 'VA', label: 'Virginia'},
  {value: 'WA', label: 'Washington'},
  {value: 'WV', label: 'West Virginia'},
  {value: 'WI', label: 'Wisconsin'},
  {value: 'WY', label: 'Wyoming'}];

export const CAN_PROVINCES = [
  {value: 'AB', label: 'Alberta'},
  {value: 'BC', label: 'British Columbia'},
  {value: 'MB', label: 'Manitoba'},
  {value: 'NB', label: 'New Brunswick'},
  {value: 'NL', label: 'Newfoundland'},
  {value: 'NS', label: 'Nova Scotia'},
  {value: 'NT', label: 'Northwest Territories'},
  {value: 'NU', label: 'Nunavut'},
  {value: 'ON', label: 'Ontario'},
  {value: 'PE', label: 'Prince Edward Island'},
  {value: 'QC', label: 'Quebec'},
  {value: 'SK', label: 'Saskatchewan'},
  {value: 'YT', label: 'Yukon'}
];

export const ISO_TO_COUNTRY_NAME = {
  "AFG": "Afghanistan",
  "ALB": "Albania",
  "DZA": "Algeria",
  "ASM": "American Samoa",
  "AND": "Andorra",
  "AGO": "Angola",
  "AIA": "Anguilla",
  "ATA": "Antarctica",
  "ATG": "Antigua and Barbuda",
  "ARG": "Argentina",
  "ARM": "Armenia",
  "ABW": "Aruba",
  "AUS": "Australia",
  "AUT": "Austria",
  "AZE": "Azerbaijan",
  "BHS": "Bahamas",
  "BHR": "Bahrain",
  "BGD": "Bangladesh",
  "BRB": "Barbados",
  "BLR": "Belarus",
  "BEL": "Belgium",
  "BLZ": "Belize",
  "BEN": "Benin",
  "BMU": "Bermuda",
  "BTN": "Bhutan",
  "BOL": "Bolivia",
  "BIH": "Bosnia and Herzegovina",
  "BWA": "Botswana",
  "BVT": "Bouvet Island",
  "BRA": "Brazil",
  "VGB": "British Virgin Islands",
  "IOT": "British Indian Ocean Territory",
  "BRN": "Brunei Darussalam",
  "BGR": "Bulgaria",
  "BFA": "Burkina Faso",
  "BDI": "Burundi",
  "KHM": "Cambodia",
  "CMR": "Cameroon",
  "CAN": "Canada",
  "CPV": "Cape Verde",
  "CYM": "Cayman Islands",
  "CAF": "Central African Republic",
  "TCD": "Chad",
  "CHL": "Chile",
  "CHN": "China",
  "HKG": "Hong Kong, SAR China",
  "MAC": "Macao, SAR China",
  "CXR": "Christmas Island",
  "CCK": "Cocos (Keeling) Islands",
  "COL": "Colombia",
  "COM": "Comoros",
  "COG": "Congo (Brazzaville)",
  "COD": "Congo, (Kinshasa)",
  "COK": "Cook Islands",
  "CRI": "Costa Rica",
  "CIV": "Côte d’Ivoire",
  "HRV": "Croatia",
  "CUB": "Cuba",
  "CYP": "Cyprus",
  "CZE": "Czech Republic",
  "DNK": "Denmark",
  "DJI": "Djibouti",
  "DMA": "Dominica",
  "DOM": "Dominican Republic",
  "ECU": "Ecuador",
  "EGY": "Egypt",
  "SLV": "El Salvador",
  "GNQ": "Equatorial Guinea",
  "ERI": "Eritrea",
  "EST": "Estonia",
  "ETH": "Ethiopia",
  "FLK": "Falkland Islands (Malvinas)",
  "FRO": "Faroe Islands",
  "FJI": "Fiji",
  "FIN": "Finland",
  "FRA": "France",
  "GUF": "French Guiana",
  "PYF": "French Polynesia",
  "ATF": "French Southern Territories",
  "GAB": "Gabon",
  "GMB": "Gambia",
  "GEO": "Georgia",
  "DEU": "Germany",
  "GHA": "Ghana",
  "GIB": "Gibraltar",
  "GRC": "Greece",
  "GRL": "Greenland",
  "GRD": "Grenada",
  "GLP": "Guadeloupe",
  "GUM": "Guam",
  "GTM": "Guatemala",
  "GGY": "Guernsey",
  "GIN": "Guinea",
  "GNB": "Guinea-Bissau",
  "GUY": "Guyana",
  "HTI": "Haiti",
  "HMD": "Heard and Mcdonald Islands",
  "VAT": "Holy See (Vatican City State)",
  "HND": "Honduras",
  "HUN": "Hungary",
  "ISL": "Iceland",
  "IND": "India",
  "IDN": "Indonesia",
  "IRN": "Iran, Islamic Republic of",
  "IRQ": "Iraq",
  "IRL": "Ireland",
  "IMN": "Isle of Man",
  "ISR": "Israel",
  "ITA": "Italy",
  "JAM": "Jamaica",
  "JPN": "Japan",
  "JEY": "Jersey",
  "JOR": "Jordan",
  "KAZ": "Kazakhstan",
  "KEN": "Kenya",
  "KIR": "Kiribati",
  "PRK": "Korea (North)",
  "KOR": "Korea (South)",
  "KWT": "Kuwait",
  "KGZ": "Kyrgyzstan",
  "LAO": "Lao PDR",
  "LVA": "Latvia",
  "LBN": "Lebanon",
  "LSO": "Lesotho",
  "LBR": "Liberia",
  "LBY": "Libya",
  "LIE": "Liechtenstein",
  "LTU": "Lithuania",
  "LUX": "Luxembourg",
  "MKD": "Macedonia, Republic",
  "MDG": "Madagascar",
  "MWI": "Malawi",
  "MYS": "Malaysia",
  "MDV": "Maldives",
  "MLI": "Mali",
  "MLT": "Malta",
  "MHL": "Marshall Islands",
  "MTQ": "Martinique",
  "MRT": "Mauritania",
  "MUS": "Mauritius",
  "MYT": "Mayotte",
  "MEX": "Mexico",
  "FSM": "Micronesia, Federated States",
  "MDA": "Moldova",
  "MCO": "Monaco",
  "MNG": "Mongolia",
  "MNE": "Montenegro",
  "MSR": "Montserrat",
  "MAR": "Morocco",
  "MOZ": "Mozambique",
  "MMR": "Myanmar",
  "NAM": "Namibia",
  "NRU": "Nauru",
  "NPL": "Nepal",
  "NLD": "Netherlands",
  "ANT": "Netherlands Antilles",
  "NCL": "New Caledonia",
  "NZL": "New Zealand",
  "NIC": "Nicaragua",
  "NER": "Niger",
  "NGA": "Nigeria",
  "NIU": "Niue",
  "NFK": "Norfolk Island",
  "MNP": "Northern Mariana Islands",
  "NOR": "Norway",
  "OMN": "Oman",
  "PAK": "Pakistan",
  "PLW": "Palau",
  "PSE": "Palestinian Territory",
  "PAN": "Panama",
  "PNG": "Papua New Guinea",
  "PRY": "Paraguay",
  "PER": "Peru",
  "PHL": "Philippines",
  "PCN": "Pitcairn",
  "POL": "Poland",
  "PRT": "Portugal",
  "PRI": "Puerto Rico",
  "QAT": "Qatar",
  "REU": "Réunion",
  "ROU": "Romania",
  "RUS": "Russian Federation",
  "RWA": "Rwanda",
  "BLM": "Saint-Barthélemy",
  "SHN": "Saint Helena",
  "KNA": "Saint Kitts and Nevis",
  "LCA": "Saint Lucia",
  "MAF": "Saint-Martin (French part)",
  "SPM": "Saint Pierre and Miquelon",
  "VCT": "Saint Vincent and Grenadines",
  "WSM": "Samoa",
  "SMR": "San Marino",
  "STP": "Sao Tome and Principe",
  "SAU": "Saudi Arabia",
  "SEN": "Senegal",
  "SRB": "Serbia",
  "SYC": "Seychelles",
  "SLE": "Sierra Leone",
  "SGP": "Singapore",
  "SVK": "Slovakia",
  "SVN": "Slovenia",
  "SLB": "Solomon Islands",
  "SOM": "Somalia",
  "ZAF": "South Africa",
  "SGS": "South Georgia and the South Sandwich Islands",
  "SSD": "South Sudan",
  "ESP": "Spain",
  "LKA": "Sri Lanka",
  "SDN": "Sudan",
  "SUR": "Suriname",
  "SJM": "Svalbard and Jan Mayen Islands",
  "SWZ": "Swaziland",
  "SWE": "Sweden",
  "CHE": "Switzerland",
  "SYR": "Syrian Arab Republic (Syria)",
  "TWN": "Taiwan, Republic of China",
  "TJK": "Tajikistan",
  "TZA": "Tanzania, United Republic of",
  "THA": "Thailand",
  "TLS": "Timor-Leste",
  "TGO": "Togo",
  "TKL": "Tokelau",
  "TON": "Tonga",
  "TTO": "Trinidad and Tobago",
  "TUN": "Tunisia",
  "TUR": "Turkey",
  "TKM": "Turkmenistan",
  "TCA": "Turks and Caicos Islands",
  "TUV": "Tuvalu",
  "UGA": "Uganda",
  "UKR": "Ukraine",
  "ARE": "United Arab Emirates",
  "GBR": "United Kingdom",
  "USA": "United States of America",
  "UMI": "US Minor Outlying Islands",
  "URY": "Uruguay",
  "UZB": "Uzbekistan",
  "VUT": "Vanuatu",
  "VEN": "Venezuela (Bolivarian Republic)",
  "VNM": "Viet Nam",
  "VIR": "Virgin Islands",
  "WLF": "Wallis and Futuna Islands",
  "ESH": "Western Sahara",
  "YEM": "Yemen",
  "ZMB": "Zambia",
  "ZWE": "Zimbabe"
};

export const COUNTRIES = [
  {value: "USA", label: "United States of America"},
  {value: "CAN", label: "Canada"},
  {value: "AFG", label: "Afghanistan"},
  {value: "ALB", label: "Albania"},
  {value: "DZA", label: "Algeria"},
  {value: "ASM", label: "American Samoa"},
  {value: "AND", label: "Andorra"},
  {value: "AGO", label: "Angola"},
  {value: "AIA", label: "Anguilla"},
  {value: "ATA", label: "Antarctica"},
  {value: "ATG", label: "Antigua and Barbuda"},
  {value: "ARG", label: "Argentina"},
  {value: "ARM", label: "Armenia"},
  {value: "ABW", label: "Aruba"},
  {value: "AUS", label: "Australia"},
  {value: "AUT", label: "Austria"},
  {value: "AZE", label: "Azerbaijan"},
  {value: "BHS", label: "Bahamas"},
  {value: "BHR", label: "Bahrain"},
  {value: "BGD", label: "Bangladesh"},
  {value: "BRB", label: "Barbados"},
  {value: "BLR", label: "Belarus"},
  {value: "BEL", label: "Belgium"},
  {value: "BLZ", label: "Belize"},
  {value: "BEN", label: "Benin"},
  {value: "BMU", label: "Bermuda"},
  {value: "BTN", label: "Bhutan"},
  {value: "BOL", label: "Bolivia"},
  {value: "BIH", label: "Bosnia and Herzegovina"},
  {value: "BWA", label: "Botswana"},
  {value: "BVT", label: "Bouvet Island"},
  {value: "BRA", label: "Brazil"},
  {value: "VGB", label: "British Virgin Islands"},
  {value: "IOT", label: "British Indian Ocean Territory"},
  {value: "BRN", label: "Brunei Darussalam"},
  {value: "BGR", label: "Bulgaria"},
  {value: "BFA", label: "Burkina Faso"},
  {value: "BDI", label: "Burundi"},
  {value: "KHM", label: "Cambodia"},
  {value: "CMR", label: "Cameroon"},
  {value: "CPV", label: "Cape Verde"},
  {value: "CYM", label: "Cayman Islands"},
  {value: "CAF", label: "Central African Republic"},
  {value: "TCD", label: "Chad"},
  {value: "CHL", label: "Chile"},
  {value: "CHN", label: "China"},
  {value: "HKG", label: "Hong Kong, SAR China"},
  {value: "MAC", label: "Macao, SAR China"},
  {value: "CXR", label: "Christmas Island"},
  {value: "CCK", label: "Cocos (Keeling) Islands"},
  {value: "COL", label: "Colombia"},
  {value: "COM", label: "Comoros"},
  {value: "COG", label: "Congo (Brazzaville)"},
  {value: "COD", label: "Congo, (Kinshasa)"},
  {value: "COK", label: "Cook Islands"},
  {value: "CRI", label: "Costa Rica"},
  {value: "CIV", label: "Côte d’Ivoire"},
  {value: "HRV", label: "Croatia"},
  {value: "CUB", label: "Cuba"},
  {value: "CYP", label: "Cyprus"},
  {value: "CZE", label: "Czech Republic"},
  {value: "DNK", label: "Denmark"},
  {value: "DJI", label: "Djibouti"},
  {value: "DMA", label: "Dominica"},
  {value: "DOM", label: "Dominican Republic"},
  {value: "ECU", label: "Ecuador"},
  {value: "EGY", label: "Egypt"},
  {value: "SLV", label: "El Salvador"},
  {value: "GNQ", label: "Equatorial Guinea"},
  {value: "ERI", label: "Eritrea"},
  {value: "EST", label: "Estonia"},
  {value: "ETH", label: "Ethiopia"},
  {value: "FLK", label: "Falkland Islands (Malvinas)"},
  {value: "FRO", label: "Faroe Islands"},
  {value: "FJI", label: "Fiji"},
  {value: "FIN", label: "Finland"},
  {value: "FRA", label: "France"},
  {value: "GUF", label: "French Guiana"},
  {value: "PYF", label: "French Polynesia"},
  {value: "ATF", label: "French Southern Territories"},
  {value: "GAB", label: "Gabon"},
  {value: "GMB", label: "Gambia"},
  {value: "GEO", label: "Georgia"},
  {value: "DEU", label: "Germany"},
  {value: "GHA", label: "Ghana"},
  {value: "GIB", label: "Gibraltar"},
  {value: "GRC", label: "Greece"},
  {value: "GRL", label: "Greenland"},
  {value: "GRD", label: "Grenada"},
  {value: "GLP", label: "Guadeloupe"},
  {value: "GUM", label: "Guam"},
  {value: "GTM", label: "Guatemala"},
  {value: "GGY", label: "Guernsey"},
  {value: "GIN", label: "Guinea"},
  {value: "GNB", label: "Guinea-Bissau"},
  {value: "GUY", label: "Guyana"},
  {value: "HTI", label: "Haiti"},
  {value: "HMD", label: "Heard and Mcdonald Islands"},
  {value: "VAT", label: "Holy See (Vatican City State)"},
  {value: "HND", label: "Honduras"},
  {value: "HUN", label: "Hungary"},
  {value: "ISL", label: "Iceland"},
  {value: "IND", label: "India"},
  {value: "IDN", label: "Indonesia"},
  {value: "IRN", label: "Iran, Islamic Republic of"},
  {value: "IRQ", label: "Iraq"},
  {value: "IRL", label: "Ireland"},
  {value: "IMN", label: "Isle of Man"},
  {value: "ISR", label: "Israel"},
  {value: "ITA", label: "Italy"},
  {value: "JAM", label: "Jamaica"},
  {value: "JPN", label: "Japan"},
  {value: "JEY", label: "Jersey"},
  {value: "JOR", label: "Jordan"},
  {value: "KAZ", label: "Kazakhstan"},
  {value: "KEN", label: "Kenya"},
  {value: "KIR", label: "Kiribati"},
  {value: "PRK", label: "Korea (North)"},
  {value: "KOR", label: "Korea (South)"},
  {value: "KWT", label: "Kuwait"},
  {value: "KGZ", label: "Kyrgyzstan"},
  {value: "LAO", label: "Lao PDR"},
  {value: "LVA", label: "Latvia"},
  {value: "LBN", label: "Lebanon"},
  {value: "LSO", label: "Lesotho"},
  {value: "LBR", label: "Liberia"},
  {value: "LBY", label: "Libya"},
  {value: "LIE", label: "Liechtenstein"},
  {value: "LTU", label: "Lithuania"},
  {value: "LUX", label: "Luxembourg"},
  {value: "MKD", label: "Macedonia, Republic"},
  {value: "MDG", label: "Madagascar"},
  {value: "MWI", label: "Malawi"},
  {value: "MYS", label: "Malaysia"},
  {value: "MDV", label: "Maldives"},
  {value: "MLI", label: "Mali"},
  {value: "MLT", label: "Malta"},
  {value: "MHL", label: "Marshall Islands"},
  {value: "MTQ", label: "Martinique"},
  {value: "MRT", label: "Mauritania"},
  {value: "MUS", label: "Mauritius"},
  {value: "MYT", label: "Mayotte"},
  {value: "MEX", label: "Mexico"},
  {value: "FSM", label: "Micronesia, Federated States"},
  {value: "MDA", label: "Moldova"},
  {value: "MCO", label: "Monaco"},
  {value: "MNG", label: "Mongolia"},
  {value: "MNE", label: "Montenegro"},
  {value: "MSR", label: "Montserrat"},
  {value: "MAR", label: "Morocco"},
  {value: "MOZ", label: "Mozambique"},
  {value: "MMR", label: "Myanmar"},
  {value: "NAM", label: "Namibia"},
  {value: "NRU", label: "Nauru"},
  {value: "NPL", label: "Nepal"},
  {value: "NLD", label: "Netherlands"},
  {value: "ANT", label: "Netherlands Antilles"},
  {value: "NCL", label: "New Caledonia"},
  {value: "NZL", label: "New Zealand"},
  {value: "NIC", label: "Nicaragua"},
  {value: "NER", label: "Niger"},
  {value: "NGA", label: "Nigeria"},
  {value: "NIU", label: "Niue"},
  {value: "NFK", label: "Norfolk Island"},
  {value: "MNP", label: "Northern Mariana Islands"},
  {value: "NOR", label: "Norway"},
  {value: "OMN", label: "Oman"},
  {value: "PAK", label: "Pakistan"},
  {value: "PLW", label: "Palau"},
  {value: "PSE", label: "Palestinian Territory"},
  {value: "PAN", label: "Panama"},
  {value: "PNG", label: "Papua New Guinea"},
  {value: "PRY", label: "Paraguay"},
  {value: "PER", label: "Peru"},
  {value: "PHL", label: "Philippines"},
  {value: "PCN", label: "Pitcairn"},
  {value: "POL", label: "Poland"},
  {value: "PRT", label: "Portugal"},
  {value: "PRI", label: "Puerto Rico"},
  {value: "QAT", label: "Qatar"},
  {value: "REU", label: "Réunion"},
  {value: "ROU", label: "Romania"},
  {value: "RUS", label: "Russian Federation"},
  {value: "RWA", label: "Rwanda"},
  {value: "BLM", label: "Saint-Barthélemy"},
  {value: "SHN", label: "Saint Helena"},
  {value: "KNA", label: "Saint Kitts and Nevis"},
  {value: "LCA", label: "Saint Lucia"},
  {value: "MAF", label: "Saint-Martin (French part)"},
  {value: "SPM", label: "Saint Pierre and Miquelon"},
  {value: "VCT", label: "Saint Vincent and Grenadines"},
  {value: "WSM", label: "Samoa"},
  {value: "SMR", label: "San Marino"},
  {value: "STP", label: "Sao Tome and Principe"},
  {value: "SAU", label: "Saudi Arabia"},
  {value: "SEN", label: "Senegal"},
  {value: "SRB", label: "Serbia"},
  {value: "SYC", label: "Seychelles"},
  {value: "SLE", label: "Sierra Leone"},
  {value: "SGP", label: "Singapore"},
  {value: "SVK", label: "Slovakia"},
  {value: "SVN", label: "Slovenia"},
  {value: "SLB", label: "Solomon Islands"},
  {value: "SOM", label: "Somalia"},
  {value: "ZAF", label: "South Africa"},
  {value: "SGS", label: "South Georgia and the South Sandwich Islands"},
  {value: "SSD", label: "South Sudan"},
  {value: "ESP", label: "Spain"},
  {value: "LKA", label: "Sri Lanka"},
  {value: "SDN", label: "Sudan"},
  {value: "SUR", label: "Suriname"},
  {value: "SJM", label: "Svalbard and Jan Mayen Islands"},
  {value: "SWZ", label: "Swaziland"},
  {value: "SWE", label: "Sweden"},
  {value: "CHE", label: "Switzerland"},
  {value: "SYR", label: "Syrian Arab Republic (Syria)"},
  {value: "TWN", label: "Taiwan, Republic of China"},
  {value: "TJK", label: "Tajikistan"},
  {value: "TZA", label: "Tanzania, United Republic of"},
  {value: "THA", label: "Thailand"},
  {value: "TLS", label: "Timor-Leste"},
  {value: "TGO", label: "Togo"},
  {value: "TKL", label: "Tokelau"},
  {value: "TON", label: "Tonga"},
  {value: "TTO", label: "Trinidad and Tobago"},
  {value: "TUN", label: "Tunisia"},
  {value: "TUR", label: "Turkey"},
  {value: "TKM", label: "Turkmenistan"},
  {value: "TCA", label: "Turks and Caicos Islands"},
  {value: "TUV", label: "Tuvalu"},
  {value: "UGA", label: "Uganda"},
  {value: "UKR", label: "Ukraine"},
  {value: "ARE", label: "United Arab Emirates"},
  {value: "GBR", label: "United Kingdom"},
  {value: "UMI", label: "US Minor Outlying Islands"},
  {value: "URY", label: "Uruguay"},
  {value: "UZB", label: "Uzbekistan"},
  {value: "VUT", label: "Vanuatu"},
  {value: "VEN", label: "Venezuela (Bolivarian Republic)"},
  {value: "VNM", label: "Viet Nam"},
  {value: "VIR", label: "Virgin Islands"},
  {value: "WLF", label: "Wallis and Futuna Islands"},
  {value: "ESH", label: "Western Sahara"},
  {value: "YEM", label: "Yemen"},
  {value: "ZMB", label: "Zambia"},
  {value: "ZWE", label: "Zimbabe"}
];

export const CATEGORY_FILTERS = [
  {name: "made in USA", icon: MadeInUsaIcon, value: "made_in_usa", height: 14},
  {name: "ecofriendly", icon: Ecofriendly, value: "eco_friendly", height: 14},
  {name: "handmade", icon: Handmade, value: "hand_made", height: 13},
  {name: "social good", icon: SocialGood, value: "charitable", height: 11}
];

export const CATEGORY_FILTERS_VALUE_TO_NAME = {
  "made_in_usa": "made in USA",
  "eco_friendly": "ecofriendly",
  "hand_made": "handmade",
  "charitable": "social good"
};

export const SHOP_ALL_CATEGORY = 'All Products';
export const JUST_FOR_YOU_CATEGORY = 'Just For You';



/** WEBPACK FOOTER **
 ** ./src/consts.js
 **/